function toFiniteAmount(value) {
  if (value === null || value === undefined || value === '') return null;
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : null;
}

function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;

  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    if (typeof atob !== 'function') return null;
    const decoded = atob(padded);
    return JSON.parse(decoded);
  } catch (_) {
    return null;
  }
}

function getRetentionAmountFromRequestPayload(requestPayload) {
  if (!requestPayload) return null;

  try {
    const payload = typeof requestPayload === 'string'
      ? JSON.parse(requestPayload)
      : requestPayload;
    const dte = decodeJwtPayload(payload?.documento || payload?.json);
    if (!dte) return null;

    const resumen = dte.resumen || {};
    const summaryCandidates = [
      resumen.totalIvaRetenido,
      resumen.totalIVAretenido,
      resumen.ivaRetenido,
    ];
    for (const candidate of summaryCandidates) {
      const amount = toFiniteAmount(candidate);
      if (amount !== null) return amount;
    }

    if (Array.isArray(dte.cuerpoDocumento)) {
      return dte.cuerpoDocumento.reduce(
        (sum, item) => sum + (toFiniteAmount(item?.ivaRetenido) ?? 0),
        0,
      );
    }
  } catch (_) {
    return null;
  }

  return null;
}

export function getDocumentAmount(document = {}) {
  const safeDocument = document || {};
  const tipoDte = String(safeDocument.tipo_dte || safeDocument.tipoDte || '').trim();

  if (tipoDte === '07') {
    const retentionCandidates = [
      safeDocument.total_iva_retenido,
      safeDocument.totalIvaRetenido,
      safeDocument.totalIVAretenido,
      safeDocument.ivaRetenido,
    ];

    for (const candidate of retentionCandidates) {
      const amount = toFiniteAmount(candidate);
      if (amount !== null) return amount;
    }

    const payloadAmount = getRetentionAmountFromRequestPayload(safeDocument.request_payload);
    if (payloadAmount !== null) return payloadAmount;
  }

  return toFiniteAmount(safeDocument.monto_total) ?? 0;
}

export function getDocumentAmountLabel(document = {}) {
  const safeDocument = document || {};
  return String(safeDocument.tipo_dte || safeDocument.tipoDte || '').trim() === '07'
    ? 'Total IVA Retenido'
    : 'Monto Total';
}
